import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$assign from 'babel-runtime/core-js/object/assign';

/* eslint-disable max-lines */
import { getTagList } from '@/api/common/index.js';
import { updateMaterialInfo } from '@/api/res_store/update';
import { getMaterialInfo } from '@/api/res_store/info';
import { createMaterial } from '@/api/res_store/create';
import { contrastObj } from '@/utils/index';
import * as api from '@/config/api';
import { v2Host } from '@/config/host';

export default {
  data: function data() {
    var checkALength = function checkALength(rule, value, callback) {
      if (value.length > 50) {
        return callback(new Error('动作描述标签数量不能超过50'));
      }
      return callback();
    };
    return {
      bLoading: false,
      oInfo: {},
      oAnimation: {
        bLoading: true,
        aList: [],
        aLocalList: [],
        bIptVisible: false,
        sIptVal: ''
      },
      oType: {
        bLoading: true,
        aList: []
      },
      aFileList: [],
      aIconList: [],
      oData: {
        name: '',
        tag1_names: [],
        file_path: '',
        img_file: '',
        tag2_names: '',
        image_origin_name: '',
        file_origin_name: ''
      },
      oRule: {
        name: [{ required: true, message: '请填写动作名称', trigger: 'change' }],
        tag1_names: [{ required: true, message: '请选择动作', trigger: 'change' }, { validator: checkALength, trigger: 'change' }],
        img_file: [{ required: true, message: '请上传预览图片', trigger: 'change' }],
        file_path: [{ required: true, message: '请上传动作文件', trigger: 'change' }],
        tag2_names: [{ required: true, message: '请选择动作类型', trigger: 'change' }]
      }
    };
  },

  computed: {
    uploadUrl: {
      get: function get() {
        return v2Host + '/upload/file';
      }
    },
    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    }
  },
  mounted: function mounted() {
    this.fnGetAnimation();
    this.fnGetType();
    if (this.$route.params.id) {
      this.fnGetInfo();
    }
  },

  methods: {
    // 获取单个详情
    fnGetInfo: function fnGetInfo() {
      var _this = this;

      this.bLoading = true;
      getMaterialInfo({
        id: this.$route.params.id
      }).then(function (res) {
        _this.oInfo = res.data.data.info;
        _this.bLoading = false;
        _this.oData.name = _this.oInfo.name;
        _this.oData.tag1_names = _this.oInfo.tag1_list.map(function (e) {
          return e.name;
        });
        _this.oData.file_path = _this.oInfo.file_url;
        _this.oData.img_file = _this.oInfo.image_url;
        _this.oData.tag2_names = _this.oInfo.tag2_list.map(function (e) {
          return e.name;
        }).join();
        _this.oData.image_origin_name = _this.oInfo.image_origin_name;
        _this.oData.file_origin_name = _this.oInfo.file_origin_name;
        _this.aFileList = [{
          url: _this.oInfo.file_url,
          name: _this.oInfo.file_origin_name
        }];
        _this.aIconList = [{
          url: _this.oInfo.image_url,
          name: _this.oInfo.image_origin_name
        }];
        var self = _this;
        setTimeout(function () {
          if (self.$refs.form) {
            self.$refs.form.clearValidate();
          }
        }, 100);
        var sName = _this.oInfo.name.length > 20 ? _this.oInfo.name.substr(0, 20) + '...' : _this.oInfo.name;
        document.querySelector('.app-breadcrumb .u-breadcrumb-cur').innerHTML = '编辑：' + sName;
      }).catch(function () {
        _this.bLoading = false;
      });
    },

    // 获取动作
    fnGetAnimation: function fnGetAnimation() {
      var _this2 = this;

      this.oAnimation.bLoading = true;
      getTagList({
        type: 2
      }).then(function (res) {
        _this2.oAnimation.bLoading = false;
        _this2.oAnimation.aList = res.data.data.tags;
      }).catch(function () {});
    },
    fnOnUploadError: function fnOnUploadError() {
      this.$message.warning('文件上传出错！');
    },

    // 获取动作类型
    fnGetType: function fnGetType() {
      var _this3 = this;

      this.oType.bLoading = true;
      getTagList({
        type: 5
      }).then(function (res) {
        _this3.oType.bLoading = false;
        _this3.oType.aList = res.data.data.tags;
        // this.oData.tag2_names = this.oType.aList[0].id
      }).catch(function () {});
    },

    // 点击新增标签
    fnShowStyleTag: function fnShowStyleTag() {
      var _this4 = this;

      this.oStyle.bIptVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.styleIpt.$refs.input.focus();
      });
    },
    fnShowAnimationTag: function fnShowAnimationTag() {
      var _this5 = this;

      this.oAnimation.bIptVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.animationIpt.$refs.input.focus();
      });
    },

    // 保存标签
    fnAnimationSaveTag: function fnAnimationSaveTag() {
      var sVal = this.oAnimation.sIptVal.trim();
      if (sVal) {
        if (this.oData.tag1_names.indexOf(sVal) === -1) {
          var aStyle = this.oAnimation.aList.map(function (e) {
            return e.name;
          });
          if (aStyle.indexOf(sVal) !== -1) {
            this.$message({
              message: '添加失败，标签已存在',
              type: 'warning'
            });
          } else {
            this.oData.tag1_names.push(sVal);
          }
        } else {
          this.$message({
            message: '已经存在该标签',
            type: 'warning'
          });
        }
      }
      this.oAnimation.bIptVisible = false;
      this.oAnimation.sIptVal = '';
    },

    // 删除标签
    fnCloseAnimationTag: function fnCloseAnimationTag(tag) {
      this.oData.tag1_names.splice(this.oData.tag1_names.indexOf(tag), 1);
    },
    fnChangeFile: function fnChangeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    // 上传动作文件
    fnSuccessFile: function fnSuccessFile(response, file, fileList) {
      var _this6 = this;

      if (response.code === 0) {
        this.oData.file_path = response.data.file_path;
        this.oData.file_origin_name = response.data.origin_name;
        this.$refs.form.validateField('file_path');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this6.oData.file_path = '';
          _this6.aFileList = [];
        });
      }
    },
    fnRemoveFile: function fnRemoveFile() {
      this.oData.file_path = '';
    },
    fnRemoveIcon: function fnRemoveIcon() {
      this.oData.img_file = '';
    },
    fnSuccessIcon: function fnSuccessIcon(response, file, fileList) {
      var _this7 = this;

      if (response.code === 0) {
        this.oData.img_file = response.data.file_path;
        this.oData.image_origin_name = response.data.origin_name;
        this.$refs.form.validateField('img_file');
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this7.oData.img_file = '';
          _this7.aIconList = [];
        });
      }
    },
    fnClickList: function fnClickList(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    },
    fnSubmit: function fnSubmit() {
      var _this8 = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this8.bLoading = true;
          var submitPromist = void 0,
              oData = void 0,
              oInfo = void 0;
          if (_this8.$route.params.id) {
            submitPromist = updateMaterialInfo;
            oData = _Object$assign({}, _this8.oData);
            oInfo = _Object$assign({}, _this8.oInfo);
            oInfo.tag1_names = oInfo.tag1_list.map(function (e) {
              return e.name;
            });
            oInfo.tag2_names = oInfo.tag2_list.map(function (e) {
              return e.name;
            }).join();
            oInfo.img_file = oInfo.image_url;
            oInfo.file_path = oInfo.file_url;
            oData.ext_config = _JSON$stringify(oData.ext_config);
            oInfo.ext_config = _JSON$stringify(oInfo.ext_config);
            oData = contrastObj(oData, oInfo);
            if (_Object$keys(oData).length === 0) {
              _this8.$message({
                message: '没有任何修改',
                type: 'warning'
              });
              _this8.bLoading = false;
              return;
            }
            oData.queryId = _this8.$route.params.id;
            if (oData.file_path) {
              oData.file_type = 'local';
              oData.file_origin_name = _this8.oData.file_origin_name;
            }
            oData.tag1_names && (oData.tag1_names = oData.tag1_names.join());
          } else {
            submitPromist = createMaterial;
            oData = JSON.parse(_JSON$stringify(_this8.oData));
            oData.res_type = 2;
            oData.file_type = 'local';
            oData.tag1_names = oData.tag1_names.join();
          }
          submitPromist(oData).then(function (res) {
            self.bLoading = false;
            self.$message({
              message: 'success',
              type: 'success'
            });
            if (_this8.$route.params.id) {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.back(-1);
                }
              }, 3000);
            } else {
              setTimeout(function () {
                if (location.href.indexOf('edit') !== -1 || location.href.indexOf('add') !== -1) {
                  self.$router.push({ name: 'repo.itav-material.action-list' });
                }
              }, 3000);
            }
          }).catch(function () {
            _this8.bLoading = false;
          });
        }
      });
    },
    fnBackBtn: function fnBackBtn() {
      var _this9 = this;

      var h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [h('p', null, '\u786E\u8BA4\u8FD4\u56DE\uFF1F\u82E5\u7EE7\u7EED\uFF0C\u5F53\u524D\u5DF2\u586B\u5199\u7684\u5185\u5BB9\u5747\u4F1A\u4E22\u5931\u3002')]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            _this9.$router.back(-1);
          }
          done();
        }
      }).then(function (action) {});
    }
  }
};